import { IMAGE_DEFAULT_SIZE } from 'root/consts';

type ImageWithSize = {
  height?: number | null;
  width?: number | null;
};

export const getImageSize = (image?: ImageWithSize) => {
  if (!image) {
    return { height: IMAGE_DEFAULT_SIZE, width: IMAGE_DEFAULT_SIZE };
  }
  return {
    height: image.height && image.height > 0 ? image.height : IMAGE_DEFAULT_SIZE,
    width: image.width && image.width > 0 ? image.width : IMAGE_DEFAULT_SIZE,
  };
};
